<app-page-header title="Prodotti" [showBack]="false">
  <div class="d-flex align-items-center">
    @if (authService.hasRole('PRODUCT_CAN_WRITE')) {
    <button class="mr-4" mat-flat-button color="primary" [routerLink]="['new']">Crea Prodotto</button>
    }

    <bitf-search
      (valueChanges)="searchText = $event"
      placeholder="Cerca prodotto"
      label="Cerca prodotto"
      [isInToolbar]="true"
      [hasSearchIcon]="false"
    ></bitf-search>
  </div>
</app-page-header>

<div class="container-fluid py-3">
  <app-dynamic-table
    [service]="productService"
    [columns]="dataColumns"
    [showDeleteBtn]="authService.hasRole('PRODUCT_CAN_DELETE')"
    [searchText]="searchText"
  ></app-dynamic-table>
</div>
